import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-sliding-pane/dist/react-sliding-pane.css';

import React, { useContext, useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import SlidingPane from 'react-sliding-pane';
import createTrigger from 'react-use-trigger';

import AppContext from '../../store/app-context';

import AddIcon from '@mui/icons-material/Add';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import SendIcon from '@mui/icons-material/Send';
import SaveIcon from '@mui/icons-material/Save';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { IconButton, Menu, MenuItem, Paper, Toolbar, Tooltip, Typography } from '@mui/material';
import { DataGridPro, GridRowHeightParams, GridSelectionModel, GridSortModel, useGridApiRef } from '@mui/x-data-grid-pro';
import { LicenseInfo } from '@mui/x-license-pro';

import AlertDialog from '../../components/AlertDialog';
import MapControl from '../../components/MapControl';
import ScheduleDialog from '../../components/ScheduleDialog';
import Styles from '../../lib/Styles';
import APIService from '../../shared/api-service';
import ICampaign from '../../shared/ICampaign';
import IData from '../../shared/IData';
import Add from '../add/Add';
import View from '../view/View';
import classes from './enhancedtable.module.scss';

LicenseInfo.setLicenseKey(
  'aa7e48e362f3cba688cbafe7a00d9474T1JERVI6NDE2MzMsRVhQSVJZPTE2ODEzMzgyMzA4MzAsS0VZVkVSU0lPTj0x',
);

interface EnhancedTableToolbarProps {
  titleIcon: any;
  type: string;
  numSelected: number;
  setIsPaneOpen: Function;
  title: string;
  readOnly: boolean;
  deletable: boolean;
  cancelable: boolean;
  handleEdit: Function;
  handleView: Function;
  handleDelete: Function;
  handleSend: Function;
  handleScheduleSend: Function;
  handleUnschedule: Function;
  handleLayoutPersistence: Function;
}


function EnhancedTableToolbar(props: EnhancedTableToolbarProps) {
  const cx = new Styles(classes).cx;
  const { titleIcon = null, type, numSelected, setIsPaneOpen, title, readOnly, deletable, cancelable, handleEdit, handleView, handleDelete, handleSend, handleScheduleSend, handleUnschedule, handleLayoutPersistence } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const options = [
    { key: 'save', display: (<div className={cx('menu-item')}><SaveIcon /><div className={cx('menu-text')}>Save Layout</div></div>) },
    { key: 'restore', display: (<div className={cx('menu-item')}><ContentCopyIcon /><div className={cx('menu-text')}>Apply Saved Layout</div></div>) },
    { key: 'reset', display: (<div className={cx('menu-item')}><RestartAltIcon /><div className={cx('menu-text')}>Reset Layout</div></div>) }
  ];

  const handleClickListItem = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // onEdit() is only used to keep typescript compiler happy.  All it does is invoke the passed in handleEdit function.
  const onEdit = () => {
    handleEdit();
  }

  // onView() is only used to keep typescript compiler happy.  All it does is invoke the passed in handleView function.
  const onView = () => {
    handleView();
  }

  const canSend = ("true" === localStorage.getItem('canSend'));
  const canCreate = ("true" === localStorage.getItem('canCreate'));

  const key = `${type}TableLayout`
  const storedState: any = localStorage.getItem(key);

  return (
    <Toolbar
      className={cx('root1')}
    >
      {numSelected > 0 ? (
        <Typography className={cx('title')} color="inherit" variant="h6">
          {title} {titleIcon ? <>{titleIcon}</> : <></>}[{numSelected} selected]
        </Typography>
      ) : (
        <Typography className={cx('title')} variant="h6" id="tableTitle">
          {title} {titleIcon ? <>{titleIcon}</> : <></>}
        </Typography>
      )}
      {numSelected === 0 && !readOnly && canCreate ? (
        <Tooltip arrow title="Add Campaign">
          <IconButton aria-label="add" onClick={() => setIsPaneOpen(true)}>
            <AddIcon />
          </IconButton>
        </Tooltip>
      ) : (<div></div>)}
      {numSelected > 0 && cancelable ? (
        <Tooltip arrow title="Cancel Campaign Schedule">
          <IconButton aria-label="cancel campaign schedule" onClick={() => handleUnschedule()}>
            <CancelScheduleSendIcon />
          </IconButton>
        </Tooltip>
      ) : (<div></div>)}
      {numSelected === 1 && !readOnly && !!canSend ? (
        <>
          <Tooltip arrow title="Send Campaign">
            <IconButton aria-label="send" onClick={() => handleSend()}>
              <SendIcon />
            </IconButton>
          </Tooltip>
        </>
      ) : (<div></div>)}
      {numSelected > 0 && !readOnly && !!canSend ? (
        <Tooltip arrow title="Schedule Campaign">
          <IconButton aria-label="schedule send" onClick={() => handleScheduleSend()}>
            <ScheduleSendIcon />
          </IconButton>
        </Tooltip>
      ) : (<div></div>)}
      {numSelected === 1 && !readOnly && canCreate ? (
        <Tooltip arrow title="Edit Campaign">
          <IconButton aria-label="edit" onClick={onEdit}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      ) : (<div></div>)}
      {numSelected === 1 && (readOnly || !canCreate) ? (
        <Tooltip arrow title="View Campaign">
          <IconButton aria-label="view" onClick={() => cancelable ? onEdit() : onView()}>
            <AssignmentIcon />
          </IconButton>
        </Tooltip>
      ) : (<div></div>)}
      {numSelected > 0 && deletable && canCreate ? (
        <Tooltip arrow title="Delete Campaign">
          <IconButton aria-label="delete" onClick={() => handleDelete()}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <div></div>
      )}
      <div className={cx('list-settings')}>
        <Tooltip arrow title="Settings">
          <IconButton aria-label="delete" onClick={handleClickListItem}>
            <SettingsIcon />
          </IconButton>
        </Tooltip>
        <Menu
          id="lock-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "lock-button",
            role: "listbox"
          }}
        >
          {options.map((option, index) => (
            <div key={index}>
              {(option.key === 'reset') &&
                <hr />
              }
              <MenuItem
                disabled={((option.key === 'restore') && !storedState)}
                key={option.key}
                onClick={(event) => {
                  setAnchorEl(null);
                  handleLayoutPersistence(event, option.key)
                }}
              >
                {option.display}
              </MenuItem>
            </div>
          ))}
        </Menu>
      </div>
    </Toolbar>
  );
};

export interface AlertDialogContent {
  title: string;
  body: any;
  yesText: string;
  noText: string;
  yesCallback: Function;
  noCallback: Function;
}

export default function EnhancedTable(props: any) {
  const { listOpenMapIds }: { listOpenMapIds: Array<any> } = useContext(AppContext);
  const type: string = props.type;
  const sortModel: GridSortModel | undefined = props.sortModel;
  const hideFields = props.hideFields;

  // The 'map' field is special.  Its value is not set by the data coming back from the back-end API.  Instead, we set the value of the 'map' field programmatically.
  // The first character of the 'map' field will be set to either ':' or '.' based on if we have a non-zero latitude or not.  The characters beyond the first
  // will be comprised of a time value since 1970.  This allows us to do a comparison two levels deep, first on the initial character, then on the time field.
  // Note: ':', and '.' were chosen because one appears before the ASCII number characters and the other appears after.
  const rows: Array<IData> = props.rows.map((row: any) => {
    const date = (type === 'pending') ? row.createdDateTime : (type === 'scheduled') ? row.scheduledDateTime : row.submittedDateTime;
    const timeSince1970 = (new Date(date)).getTime();
    row.map = ((row.geoFenceLatitude !== 0) ? ':' : '.') + timeSince1970;
    return row;
  });

  const reloadData: Function = props.reloadData;
  const readOnly: boolean = props.readOnly;
  const deletable: boolean = props.deletable;
  const cancelable: boolean = props.cancelable;
  const isLoading: boolean = props.isLoading;
  const title: string = props.title;
  const titleIcon: any = props.titleIcon;
  const triggers = useRef({ type: type, open: createTrigger(), close: createTrigger() });

  const [pageSize, setPageSize] = useState<number>(5);

  const cx = new Styles(classes).cx;
  const apiRef = useGridApiRef();

  const [initialState, setInitialState] = useState<any>({});
  const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);
  const [selectionModelStringArray, setSelectionModelStringArray] = useState<string[]>([]);
  const [isAddPaneOpen, setIsAddPaneOpen] = useState<boolean>(false);
  const [isViewPaneOpen, setIsViewPaneOpen] = useState<boolean>(false);
  const [showCancelCreateAlert, setShowCancelCreateAlert] = useState<boolean>(false);
  const [alertDialogContent, setAlertDialogContent] = useState<AlertDialogContent>();
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [showScheduleDialog, setShowScheduleDialog] = useState<boolean>(false);
  const [columns, setColumns] = useState<any>([]);
  const [togglePageChanged, setTogglePageChanged] = useState<boolean>(false);
  const refShiftHeld: any = useRef();

  // Give the triggers a 'type' property which will be set to one of the following: pending, scheduled, submitted.
  // When a user depresses the shift key and then clicks on either the Show Map / Hide Map buttons then the action
  // will be applied to all rows within the given table.
  const open: any = triggers.current.open;
  open.type = type;
  const close: any = triggers.current.close;
  close.type = type;

  useEffect(() => {
    if (!isLoading) {
      if (apiRef) {
        const state = apiRef.current.exportState();
        setInitialState(state);
      }
    }
    // eslint-disable-next-line
  }, [isLoading])

  // Keeping Typescript happy.  We are converting from GridSelectionModel[] to string[] here, as downstream code requires string[] to work with.
  useEffect(() => {
    const a: any = selectionModel;
    setSelectionModelStringArray(a);
  }, [selectionModel])

  const isMapOpen = (rowId: string) => {
    const index = listOpenMapIds.findIndex((obj: any) => obj.rowId === rowId);
    return index >= 0;
  }

  const MapCtrl = (row: any) => {
    const index = listOpenMapIds.findIndex((obj: any) => obj.rowId === row.row.id);
    const mapIsAlreadyOpen = index >= 0;

    return (
      <div style={{ display: 'block' }}>
        <MapControl {...row.row} apiRef={apiRef} isOpen={mapIsAlreadyOpen} getShiftHeld={() => refShiftHeld.current} triggers={triggers.current} rowId={row.row.id} />
      </div>
    )
  }

  const CellRenderer = (params: any, isDateTime: boolean = false) => {
    let value = params.value ? isDateTime ? (new Date(params.value)).toLocaleString() : params.value : '';
    if (params.colDef.type === 'boolean') {
      value = params.value ? 'True' : params.value === false ? 'False' : '';
      return (<div>{value}</div>)
    } else {
      return (
        <Tooltip title={params.value ? params.value : ''} arrow>
          <span className={cx("table-cell-truncate")}>{value}</span>
        </Tooltip>
      )
    }
  }

  // When the user sorts the 'map' field in ascending order, the rows with maps will appear at the top of the list and they will also be sorted within their groups based on the time field in descending order.
  // When the user sorts the 'map' field in descending order, the rows with maps will appear at the bottom of the list and they will also be sorted within their groups based on the time field in descending order.
  const mapComparator = (v1: string, v2: string) => {
    const c1 = v1.substring(0, 1);
    const c2 = v2.substring(0, 1);
    if (c1 > c2) {
      return -1;
    } else if (c1 < c2) {
      return 1
    } else {
      const t1: number = parseInt(v1.substring(1));
      const t2: number = parseInt(v2.substring(1));
      if (t1 > t2) {
        return (c1 === ':') ? -1 : 1;
      } else if (t1 < t2) {
        return (c1 === ':') ? 1 : -1;
      } else {
        return 0;
      }
    }
  }

  useEffect(() => {
    const cols = [
      {
        "field": "__check__",
        "hideable": false
      },
      {
        "field": "map",
        "headerName": "Map",
        "renderCell": (params: any) => (
          <MapCtrl row={params.row} />
        ),
        "sortComparator": mapComparator,
        "filterable": false,
        "width": 155,
        "minWidth": 155
      },
      {
        "field": "scheduledDateTime",
        "headerName": "Scheduled",
        "type": "dateTime",
        "editable": false,
        "width": 180,
        "renderCell": (params: any) => CellRenderer(params, true)
      },
      {
        "field": "makes",
        "headerName": "Makes",
        "description": "One or more makes",
        "type": "string",
        "editable": false,
        "width": 150,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 120
      },
      {
        "field": "models",
        "headerName": "Models",
        "type": "string",
        "editable": false,
        "width": 150,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 120
      },
      {
        "field": "years",
        "headerName": "Years",
        "type": "string",
        "editable": false,
        "width": 150,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 110
      },
      {
        "field": "states",
        "headerName": "States",
        "type": "string",
        "editable": false,
        "width": 150,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 110
      },
      {
        "field": "zipCodes",
        "headerName": "Zip Codes",
        "type": "string",
        "editable": false,
        "width": 150,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 140
      },
      {
        "field": "title",
        "headerName": "Title",
        "type": "string",
        "editable": false,
        "width": 250,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 100
      },
      {
        "field": "messageBody",
        "headerName": "Content",
        "type": "string",
        "editable": false,
        "width": 350,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 120
      },
      {
        "field": "url",
        "headerName": "URL",
        "type": "string",
        "editable": false,
        "width": 300,
        "renderCell": (params: any) => (
          <a href={params.value} target="_blank" rel="noopener noreferrer">{params.value}</a>
        ),
        "minWidth": 150
      },
      {
        "field": "registeredAfterDate",
        "headerName": "Registered After",
        "type": "dateTime",
        "editable": false,
        "width": 180,
        "renderCell": (params: any) => CellRenderer(params, true),
        "minWidth": 180
      },
      {
        "field": "registeredBeforeDate",
        "headerName": "Registered Before",
        "type": "dateTime",
        "editable": false,
        "width": 180,
        "renderCell": (params: any) => CellRenderer(params, true),
        "minWidth": 180
      },
      {
        "field": "createdDateTime",
        "headerName": "Created",
        "type": "dateTime",
        "editable": false,
        "width": 180,
        "renderCell": (params: any) => CellRenderer(params, true),
        "minWidth": 180
      },
      {
        "field": "submittedDateTime",
        "headerName": "Sent",
        "type": "dateTime",
        "editable": false,
        "width": 180,
        "renderCell": (params: any) => CellRenderer(params, true),
        "minWidth": 180
      },
      {
        "field": "id",
        "headerName": "Id",
        "type": "string",
        "editable": false,
        "width": 220,
        "renderCell": (params: any) => CellRenderer(params),
        "hideable": false,
        "minWidth": 220
      },
      {
        "field": "geoFenceStreetAddress",
        "headerName": "GeoFence Street",
        "type": "string",
        "editable": false,
        "width": 250,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 150
      },
      {
        "field": "geoFenceCity",
        "headerName": "GeoFence City",
        "type": "string",
        "editable": false,
        "width": 160,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 160
      },
      {
        "field": "geoFenceState",
        "headerName": "GeoFence State",
        "type": "string",
        "editable": false,
        "width": 120,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 120
      },
      {
        "field": "geoFenceZipCode",
        "headerName": "GeoFence ZipCode",
        "type": "number",
        "editable": false,
        "width": 150,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 150
      },
      {
        "field": "geoFenceLatitude",
        "headerName": "GeoFence Latitude",
        "type": "number",
        "editable": false,
        "width": 150,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 150
      },
      {
        "field": "geoFenceLongitude",
        "headerName": "GeoFence Longitude",
        "type": "number",
        "editable": false,
        "width": 150,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 150
      },
      {
        "field": "geoFenceRadiusInMiles",
        "headerName": "GeoFence Radius (Miles)",
        "type": "number",
        "editable": false,
        "width": 180,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 180
      },
      {
        "field": "vinTargetsOriginalFileName",
        "headerName": "VIN Filename",
        "type": "string",
        "editable": false,
        "width": 180,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 180
      },
      {
        "field": "vinTargetsDescription",
        "headerName": "VIN File Description",
        "type": "string",
        "editable": false,
        "width": 180,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 180
      },
      {
        "field": "vinTargetsClaimCheckIdentifier",
        "headerName": "VIN GUID",
        "type": "string",
        "editable": false,
        "width": 180,
        "renderCell": (params: any) => CellRenderer(params),
        "minWidth": 180
      },
      {
        "field": "bypassUserNotificationOptOut",
        "headerName": "Bypass OptOut",
        "type": "boolean",
        "editable": false,
        "width": 180,
        "renderHeader": (params: any) => (<Tooltip arrow title="If True then send message regardless of user's notification opt-out setting.">
          <div>Bypass OptOut</div>
        </Tooltip>),
        "renderCell": (params: any) => CellRenderer(params, false,),
        "minWidth": 180
      },
    ];
    setColumns(cols);
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (sortModel) {
      apiRef.current.setSortModel(sortModel)
    }
  }, [columns, apiRef, sortModel]);

  // Decorate the background of the rows for notifications to make them easier to spot.
  const decorateNotifications = () => {
    const current = apiRef.current;
    const allRowIds = current.getAllRowIds();
    if (allRowIds && allRowIds.length > 0) {
      allRowIds.forEach((rowId: any) => {
        const rowIndex = rows.findIndex((r) => r.id === rowId);
        if (rowIndex >= 0) {
          const row = rows[rowIndex];
          const element = current.getRowElement(rowId);
          if (element) {
            // Mark each row which satisifies the following condition:  (Currently only using a single boolean field.)
            if (row.bypassUserNotificationOptOut) {
              element.setAttribute('style', 'background-image: radial-gradient(lightcoral 0.00002%, transparent 0); background-size: 5px 5px;')
            } else {
              element.setAttribute('style', 'background-image: unset;')
            }
          }
        }
      })
    }
  }

  // TODO: Figure out all DataGrid events and trigger off of them versus using a timer.
  useEffect(() => {
    let timer: any = undefined;
    if (apiRef) {
      decorateNotifications();
      timer = setInterval(() => {
        decorateNotifications();
      }, 1000);
    }
    return () => {
      if (timer) {
        clearTimeout(timer);
        timer = undefined;
      }
    }
    // eslint-disable-next-line
  }, [apiRef, rows])

  useEffect(() => {
    if (columns && hideFields && hideFields.length > 0) {
      hideFields.forEach((field: string) => apiRef.current.setColumnVisibility(field, false));
    }
    // eslint-disable-next-line
  }, [columns])

  function downHandler({ key }: { key: any }) {
    if (key === 'Shift') {
      refShiftHeld.current = true;
    }
  }

  function upHandler({ key }: { key: any }) {
    if (key === 'Shift') {
      refShiftHeld.current = false;
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []);

  const selectedData = (selected: string[]): IData | undefined => {
    let data: IData | undefined = undefined;
    let index = rows.findIndex((item: IData) => item.id === selected[0]);
    if (index >= 0) {
      data = rows[index];
    }
    return data;
  }

  const handleCancel = () => {
    setIsAddPaneOpen(false);
    setIsViewPaneOpen(false);
  }

  const handleSave = (value: ICampaign) => {
    if (value.id) {
      const apiService = new APIService();
      apiService.updateCampaign(value)
        .then((data: any) => {
          reloadData();
        })
    } else {
      // A new entry is being created.
      const apiService = new APIService();
      apiService.createCampaign(value)
        .then((data: any) => {
          reloadData();
          setSelectionModelStringArray([]);
        });
    }
    setIsAddPaneOpen(false);
  }

  // This method will be invoked from the table header when the pencil icon is clicked on.
  // It should only ever be called when a single entry is selected.
  const handleEdit = () => {
    setIsAddPaneOpen(true);
  }

  // This method will be invoked from the table header when the clipboard icon is clicked on.
  // It should only ever be called when a single entry is selected.
  const handleView = () => {
    setIsViewPaneOpen(true);
  }

  /**
   * This routine is used to sift through the result array and then display an error alert dialog (with a single button: Ok) if any are found.
   * @param results - An array of results in the form of {error: boolean, result: {} | string}
   * @param fnTitle - Function which takes a boolean of 'multipleErrors' and returns a string to use for the title.  This makes it easy to handle
   *                  adding 's' on to the end of the title as needed.
   */
  const displayAnyErrors = (results: [], fnTitle: Function) => {
    const error: any = results?.find((res: any) => res.error === true);
    if (error) {
      const multipleErrors: boolean = results.reduce((acc: number, curr: any) => { return (curr.error) ? (1 + acc) : acc }, 0) > 1;
      const errorMsg: string = results.reduce((acc: string, curr: any) => { return (curr.response) ? ((acc.length > 1) ? acc + ', ' + curr.response : curr.response) : acc }, '');
      setAlertDialogContent({
        title: fnTitle(multipleErrors),
        body: `${errorMsg}`,
        yesText: 'Ok',
        noText: '',
        yesCallback: () => setShowAlert(false),
        noCallback: () => setShowAlert(false)
      });
      setShowAlert(true);
    }
  }

  const getSelectedRows = () => {
    const selectedRows = rows.filter((row) => (selectionModel.findIndex((model) => model === row.id)) >= 0)
    return selectedRows;
  }

  const getSelectedNotifications = () => {
    const selectedRows = getSelectedRows();
    const selectedVINNotifications = selectedRows.filter((row) => ((!row.bypassUserNotificationOptOut) && (row.vinTargetsClaimCheckIdentifier)));
    return selectedVINNotifications;
  }

  // Invoked (without arguments) when one entry is selected and the send icon is clicked on.
  // The AlertDialog also calls back in to this function with a boolean argument.  It is true when the user wants to proceed, else false.
  const handleSend = (response?: boolean) => {
    if (response === undefined) {
      const numSelectdVinNotifictions = getSelectedNotifications().length;
      setAlertDialogContent({
        title: 'Submit Confirmation',
        body: (<>Are you sure you want to submit the selected {numSelectdVinNotifictions > 0 ? 'VIN notification' : 'campaign'}?</>),
        yesText: 'Yes',
        noText: 'No',
        yesCallback: handleSend,
        noCallback: handleSend
      });
      setShowAlert(true);
    } else if (response === true) {
      // Yes, the user does want to send the selected campaign.
      const apiService = new APIService();
      apiService.submitCampaign(selectionModelStringArray)
        .then((results: []) => {
          displayAnyErrors(results, (multipleErrors: boolean) => `Error Sending Campaign${multipleErrors ? 's' : ''}`)
          reloadData();
          setSelectionModelStringArray([]);
        })
    }
  }

  /**
   * Used to display an alert box w/msg prior to displaying the date selection dialog.  The alert is displayed when one or more of the selected campaigns are actually
   * notifications.  This provides another opportunity for the user to abort the action they are about to take when dealing with notifications.
   * @param response: Undefined first time invoked.  Callback mechanism passes in true or false depending on the user's selection. 
   * @param selectedDate: Undefined unless a date has been selected within the callback.
   */
  const handleConfirmScheduleSend = (response?: boolean, selectedDate?: string | null) => {
    if (response === undefined) {
      const numSelectdVinNotifictions = getSelectedNotifications().length;
      const message = (numSelectdVinNotifictions > 1) ? (<>{numSelectdVinNotifictions} VIN Notification entries are selected.<br></br>Are you sure you want to schedule them?</>) :
        (numSelectdVinNotifictions === 1) ? 'A VIN Notification entry is selected.  Are you sure you want to schedule it?' :
          '';
      if (numSelectdVinNotifictions >= 1) {
        setAlertDialogContent({
          title: 'Schedule Confirmation',
          body: message,
          yesText: 'Yes',
          noText: 'No',
          yesCallback: handleConfirmScheduleSend,
          noCallback: handleConfirmScheduleSend
        });
        setShowAlert(true);
      } else {
        handleScheduleSend(selectedDate);
      }
    } else if (response === true) {
      setShowAlert(false);
      handleScheduleSend(selectedDate);
    } else if (response === false) {
      setShowScheduleDialog(false);
    }
  }

  // Invoked (without arguments) when one entry is selected and the schedule icon is clicked on.
  // The ScheduleDialog also calls back in to this function with an iso date time string if the user wants to proceed with the scheduling.
  const handleScheduleSend = (selectedDate?: string | null) => {
    if (!selectedDate) {
      setShowScheduleDialog(true);
    } else {
      // Yes, the user does want to send the selected campaigns, on: ', selectedDate, selectionModelStringArray
      const apiService = new APIService();
      apiService.scheduleCampaign(selectionModelStringArray, selectedDate)
        .then((results: []) => {
          displayAnyErrors(results, (multipleErrors: boolean) => `Error Scheduling Campaign${multipleErrors ? 's' : ''}`);
          reloadData();
          setSelectionModelStringArray([]);
        })
    }
  }

  // Invoked (without arguments) when one or more entries are selected and the delete icon is clicked on.
  // The AlertDialog also calls back in to this function with a boolean argument.  It is true when the user wants to proceed, else false.
  const handleUnschedule = (response?: boolean) => {
    if (response === undefined) {
      setAlertDialogContent({
        title: 'Confirm Unscheduling',
        body: `Are you sure you want to unschedule the ${(selectionModelStringArray.length > 1) ? selectionModelStringArray.length : ''} campaign${(selectionModelStringArray.length > 1) ? 's' : ''}?`,
        yesText: 'Yes',
        noText: 'No',
        yesCallback: handleUnschedule,
        noCallback: handleUnschedule
      });
      setShowAlert(true);
    } else if (response === true) {
      // Yes, the user wants to unschedule the selected campaign(s).
      const apiService = new APIService();
      const itemsToUnschedule = [...selectionModelStringArray];
      apiService.unscheduleCampaign(itemsToUnschedule)
        .then((results: []) => {
          displayAnyErrors(results, (multipleErrors: boolean) => `Error Unscheduling Campaign${multipleErrors ? 's' : ''}`)
          reloadData();
          setSelectionModelStringArray([]);
        });
    }
  }

  // Invoked (without arguments) when one or more entries are selected and the delete icon is clicked on.
  // The AlertDialog also calls back in to this function with a boolean argument.  It is true when the user wants to proceed, else false.
  const handleDelete = (response?: boolean) => {
    if (response === undefined) {
      setAlertDialogContent({
        title: 'Confirm Delete',
        body: `Are you sure you want to delete the ${(selectionModelStringArray.length > 1) ? selectionModelStringArray.length : ''} campaign${(selectionModelStringArray.length > 1) ? 's' : ''}`,
        yesText: 'Yes',
        noText: 'No',
        yesCallback: handleDelete,
        noCallback: handleDelete
      });
      setShowAlert(true);
    } else if (response === true) {
      // Yes, the user wants to delete the selected campaign.
      const apiService = new APIService();
      const itemsToDelete = [...selectionModelStringArray];
      apiService.deleteCampaign(itemsToDelete)
        .then((results: []) => {
          displayAnyErrors(results, (multipleErrors: boolean) => `Error Deleting Campaign${multipleErrors ? 's' : ''}`)
          reloadData();
          setSelectionModelStringArray([]);
        });
    }
  }

  const handleDuplicate = (campaign: ICampaign) => {
    setAlertDialogContent({
      title: 'Confirm Duplication',
      body: 'Create a new pending campaign from the selected one?',
      yesText: 'Yes',
      noText: 'No',
      yesCallback: () => handleDuplicatePostConfirm(campaign),
      noCallback: () => { }
    });
    setShowAlert(true);
  }

  const handleDuplicatePostConfirm = (campaign: ICampaign) => {
    // Yes, the user wants to duplicate the selected campaign.
    const apiService = new APIService();
    apiService.createCampaign(campaign)
      .then((data: any) => {
        reloadData("pending");
      });
  }

  // Invoked (without arguments) when user want to reset the table layout.
  // The AlertDialog also calls back in to this function with a boolean argument.  It is true when the user wants to proceed, else false.
  const handleResetLayout = (response?: boolean) => {
    if (response === undefined) {
      setAlertDialogContent({
        title: 'Confirm Reset Layout',
        body: 'Are you sure you want to reset the layout?',
        yesText: 'Yes',
        noText: 'No',
        yesCallback: handleResetLayout,
        noCallback: handleResetLayout
      });
      setShowAlert(true);
    } else if (response === true) {
      // Yes, the user wants to reset the layout.
      apiRef.current.restoreState(initialState);
      // Bug 7050: When a column has been relocated and then pinned we need to restore the state twice.  First to unpin it, and then to relocate it.
      // Note: No local useEffect hooks trigger when restoreState() is invoked, therefore, all of the re-rendering is being done by the grid control itself.
      setTimeout(() => {
        apiRef.current.restoreState(initialState);
      }, 0)
    }
  }

  // Invoked (without arguments) when user want to apply the stored table layout.
  // The AlertDialog also calls back in to this function with a boolean argument.  It is true when the user wants to proceed, else false.
  const handleRestoreLayout = (response?: boolean) => {
    if (response === undefined) {
      setAlertDialogContent({
        title: 'Confirm Apply Layout',
        body: 'Are you sure you want to apply the saved layout?',
        yesText: 'Yes',
        noText: 'No',
        yesCallback: handleRestoreLayout,
        noCallback: handleRestoreLayout
      });
      setShowAlert(true);
    } else if (response === true) {
      // Yes, the user wants to apply the stored layout.
      const key = `${type}TableLayout`
      const storedState: any = localStorage.getItem(key);
      if (storedState) {
        const state = JSON.parse(storedState);
        apiRef.current.restoreState(state);
      }
    }
  }

  // Invoked (without arguments) when user want to save the table layout.
  // The AlertDialog also calls back in to this function with a boolean argument.  It is true when the user wants to proceed, else false.
  const handleSaveLayout = (response?: boolean) => {
    if (response === undefined) {
      setAlertDialogContent({
        title: 'Confirm Save Layout',
        body: (<>Are you sure you want to save the layout?<br />(Previously stored layout will be replaced.)</>),
        yesText: 'Yes',
        noText: 'No',
        yesCallback: handleSaveLayout,
        noCallback: handleSaveLayout
      });
      setShowAlert(true);
    } else if (response === true) {
      // 'Yes, the user wants to save the layout.
      const key = `${type}TableLayout`
      const state = apiRef.current.exportState();
      localStorage.setItem(key, JSON.stringify(state));
    }
  }

  const handleLayoutPersistence = (event: React.MouseEvent<HTMLElement>, action: string) => {
    switch (action) {
      case 'save':
        handleSaveLayout();
        break;
      case 'restore':
        handleRestoreLayout();
        break;
      case 'reset':
        handleResetLayout();
        break;
      default:
        console.error('Invalid action: ', action);
        break;
    }
  }

  let a: any;
  //TODO: Fix this
  useEffect(() => {
    Modal.setAppElement(a);
    return () => {
      //cleanup
    };
  }, [a]);

  const dat = {
    rowLength: 3,
    maxColumns: 5,
    pageSize: pageSize,
    rowsPerPageOptions: [5, 10, 25, 50, 100, 500, 1000],
    pagination: true,
    columns: columns,
    rows: rows
  }

  return (
    <div ref={(ref: any) => a = ref} className={cx('root')} aria-hidden={false}>
      <SlidingPane
        ariaHideApp={false}
        overlayClassName={cx('slidingpane-overlay-class')}
        isOpen={isAddPaneOpen}
        width='580px'
        title={(selectionModelStringArray && selectionModelStringArray.length === 1) ? cancelable ? 'View scheduled campaign' : 'Edit pending campaign' : 'Add a new campaign'}
        onRequestClose={() => {
          // triggered on "<" on left top click or on outside click
          //setIsPaneOpen(false);
          if (!readOnly) {
            setShowCancelCreateAlert(true);
          } else {
            handleCancel();
          }
        }}>
        <Add setIsPaneOpen={setIsAddPaneOpen}
          handleSave={handleSave}
          readOnly={readOnly}
          setShowCancelCreateAlert={setShowCancelCreateAlert}
          data={selectedData(selectionModelStringArray)} />
        <br />
      </SlidingPane>
      <SlidingPane
        ariaHideApp={false}
        overlayClassName={cx('slidingpane-overlay-class')}
        isOpen={isViewPaneOpen}
        width='580px'
        title='View submitted campaign'
        onRequestClose={() => {
          // triggered on "<" on left top click or on outside click
          //setIsPaneOpen(false);
          handleCancel();
        }}>
        <View setIsViewPaneOpen={setIsViewPaneOpen} handleDuplicate={handleDuplicate} data={selectedData(selectionModelStringArray)} />
        <br />
      </SlidingPane>

      <Paper className={cx('paper' + (cancelable ? ' cancelable' : ''))}>
        <EnhancedTableToolbar
          titleIcon={titleIcon}
          type={type}
          numSelected={selectionModelStringArray.length}
          setIsPaneOpen={setIsAddPaneOpen}
          title={title}
          readOnly={readOnly}
          deletable={deletable}
          cancelable={cancelable}
          handleEdit={handleEdit}
          handleView={handleView}
          handleDelete={handleDelete}
          handleSend={handleSend}
          handleScheduleSend={handleConfirmScheduleSend}
          handleLayoutPersistence={handleLayoutPersistence}
          handleUnschedule={handleUnschedule} />
        <div className={cx(type)}>
          <DataGridPro apiRef={apiRef}
            {...dat}
            loading={isLoading}
            autoHeight
            checkboxSelection
            getRowHeight={(params: GridRowHeightParams) => {
              if (isMapOpen(params.model.id)) {
                return 550;
              }
            }}
            onPageChange={(newPage: any) => setTogglePageChanged(!togglePageChanged)}
            onPageSizeChange={(newPageSize: number) => setPageSize(newPageSize)}
            onSelectionModelChange={(newSelectionModel) => {
              setSelectionModel(newSelectionModel);
            }}
            selectionModel={selectionModel}
          />
        </div>
      </Paper>
      <AlertDialog showAlert={showCancelCreateAlert}
        setShowAlert={setShowCancelCreateAlert}
        title={selectionModelStringArray.length === 0 ? 'Cancel creation of new campaign' : 'Stop editing an existing campaign'}
        body={selectionModelStringArray.length === 0 ? 'Do you want to stop creating a new campaign?' : 'Do you want to stop editing the campaign and discard all changes?'}
        agree={'Yes'}
        disagree={'No'}
        handleAgree={() => {
          setShowCancelCreateAlert(false);
          handleCancel();
        }}
        handleDisagree={() => {
          setShowCancelCreateAlert(false);
        }} />
      <AlertDialog showAlert={showAlert}
        setShowAlert={setShowAlert}
        title={alertDialogContent?.title ? alertDialogContent?.title : ''}
        body={alertDialogContent?.body ? alertDialogContent?.body : ''}
        agree={alertDialogContent?.yesText ? alertDialogContent?.yesText : ''}
        disagree={alertDialogContent?.noText ? alertDialogContent?.noText : ''}
        handleAgree={() => {
          setShowAlert(false);
          alertDialogContent?.yesCallback(true);
        }}
        handleDisagree={() => {
          setShowAlert(false);
          alertDialogContent?.noCallback(false);
        }} />
      <ScheduleDialog
        numCampaigns={selectionModelStringArray.length}
        showDialog={showScheduleDialog}
        setShowDialog={setShowScheduleDialog}
        handleAgree={(selectedDate: string | null) => {
          setShowScheduleDialog(false);
          handleScheduleSend(selectedDate);
        }}
        handleDisagree={() => {
          setShowScheduleDialog(false);
        }} />
    </div>
  );
}
